import React from "react";
export default function SecurityStandards() {
  return <section id="security-standards" className="dark bg-background text-foreground py-10 px-4">
      <div className="mx-auto max-w-4xl flex flex-col items-center justify-center">
        <p className="text-center text-sm font-medium tracking-wide text-muted-foreground/80">
          Secure client access and structured onboarding.
        </p>
      </div>
    </section>;
}